// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9s-3";
export var contentContainer = "_9s-0";
export var editorContainer = "_9s-1";
export var quillInputForm = "_9s-2";
export var zoneDivider = "_9s-4";